import React from "react"
import { Form, FormGroup, Label, Input } from "reactstrap"

import { Button } from "components/Button"

const AddCategoryForm = ({
  isLoading = false,
  value = "",
  isUpdate = false,
  onChange = () => {},
  onSubmit = () => {},
}) => {
  return (
    <Form inline className="p-4" onSubmit={e => e.preventDefault()}>
      <FormGroup className="mb-2 mr-sm-2 mb-sm-0 d-flex flex-column align-items-center">
        <Input
          value={value}
          onChange={onChange}
          className="w-75"
          type="text"
          name="category-name"
          id="category-name"
          placeholder="Type category name"
        />
      </FormGroup>
      <div className="w-100 d-flex justify-content-center mt-3">
        <Button
          isLoading={isLoading}
          size="lg"
          onClick={onSubmit}
          className="gt-btn-grad-primary btn-height d-flex justify-content-center align-items-center w-75 text-center mt-2"
          title={<div>{isUpdate ? "Update" : "Add"}</div>}
        />
      </div>
    </Form>
  )
}

export default AddCategoryForm
